import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'handleURLParamsInProgress',
  initialState: false,
  reducers: {
    setHandleURLParamsInProgress(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHandleURLParamsInProgress } = slice.actions;

export default slice.reducer;
